<template>
   <div>
      <header class="tg-header__style-five">
         <div class="tg-header__top">
            <div class="container custom-container">
               <div class="row">
                  <div class="col-lg-6">
                     <ul class="tg-header__top-info left-side list-wrap">
                        <li><i class="flaticon-phone-call"></i><a href="javascript:void(0)">+62 858-2430-7837</a></li>
                        <li><i class="flaticon-pin"></i>Kompleks Perkantoran Pemerintah Daerah</li>
                     </ul>
                  </div>
                  <div class="col-lg-6">
                     <ul class="tg-header__top-right list-wrap">
                        <li><i class="flaticon-envelope"></i><a
                              href="mailto:dikbud@konaweselatankab.go.id">dikbud@konaweselatankab.go.id</a>
                        </li>
                        <li><i class="flaticon-time"></i>Sen-Jum: 07:30 - 15:30</li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
         <div id="sticky-header" class="tg-header__area tg-header__area-five">
            <div class="container">
               <div class="row">
                  <div class="col-12">
                     <div class="tgmenu__wrap">
                        <nav class="tgmenu__nav">
                           <div class="logo">
                              <router-link to="/"><img src="assets/img/logo/logo.png" alt="Logo" /></router-link>
                           </div>
                           <div class="tgmenu__navbar-wrap tgmenu__main-menu d-none d-lg-flex">
                              <ul class="navigation">
                                 <li><router-link to="/">Beranda</router-link></li>
                                 <li
                                    :class="{ 'menu-item-has-children': true, active: $route.path.startsWith('/berita') }">
                                    <a href="#">Informasi</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/berita">Berita</router-link></li>
                                       <li><a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank">Pengumuman</a></li>
                                    </ul>
                                 </li>
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/dataPegawai',
                                       '/profilDinas',
                                       '/tujuan',
                                       '/strategi',
                                       '/kebijakan',
                                       '/program',
                                       '/strukturOrganisasi',
                                    ])
                                 }]">
                                    <a href="#">Profil</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/dataPegawai">Data Pegawai</router-link></li>
                                       <li><router-link to="/profilDinas">Profil Dinas</router-link></li>
                                       <li><router-link to="/tujuan">Tujuan</router-link></li>
                                       <li><router-link to="/strategi">Strategi</router-link></li>
                                       <li><router-link to="/kebijakan">Kebijakan</router-link></li>
                                       <li><router-link to="/program">Program</router-link></li>
                                       <li><router-link to="/strukturOrganisasi">Struktur Organisasi</router-link></li>
                                    </ul>
                                 </li>
                                 <!-- <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/bidangEkraf',
                                       '/bidangPariwisata',
                                       '/uptd',
                                       '/jabfung',
                                       '/sekretariat'
                                    ])
                                 }]">
                                    <a href="#">Unit Kerja</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/bidangEkraf">Bidang Ekonomi Kreatif</router-link></li>
                                       <li><router-link to="/bidangPariwisata">Bidang Pariwisata</router-link></li>
                                       <li><router-link to="/uptd">Unit Pelaksana Teknis Dinas</router-link></li>
                                       <li><router-link to="/jabfung">Kelompok Jabatan Fungsional</router-link></li>
                                       <li><router-link to="/sekretariat">Sekretariat</router-link></li>
                                    </ul>
                                 </li> -->
                                 <!-- <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/dikelolaPemda',
                                       '/dikelolaSwasta',
                                       '/dikelolaMasyarakat'
                                    ])
                                 }]">
                                    <a href="#">Pariwisata</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/dikelolaPemda">Destinasi Dikelola Pemda</router-link></li>
                                       <li><router-link to="/dikelolaSwasta">Destinasi Dikelola Swasta</router-link>
                                       </li>
                                       <li><router-link to="/dikelolaMasyarakat">Destinasi Dikelola
                                             Masyarakat</router-link></li>
                                    </ul>
                                 </li> -->
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/kelompokUnggulan',
                                       '/produkUnggulan'
                                    ])
                                 }]">
                                    <a href="#">Unduhan</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/regulasi">Regulasi</router-link>
                                       </li>
                                       <li><router-link to="/dataDokumen">Data & Dokumen</router-link></li>
                                    </ul>
                                 </li>
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/foto',
                                       '/video'
                                    ])
                                 }]">
                                    <a href="#">Galeri</a>
                                    <ul class="sub-menu">
                                       <li><router-link to="/foto">Foto</router-link></li>
                                       <li><router-link to="/video">Video</router-link></li>
                                    </ul>
                                 </li>
                              </ul>
                           </div>
                           <div class="mobile-nav-toggler mobile-nav-toggler-two" @click="toggleSideMenu">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
                                 <path
                                    d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M0 9C0 7.89543 0.895431 7 2 7C3.10457 7 4 7.89543 4 9C4 10.1046 3.10457 11 2 11C0.895431 11 0 10.1046 0 9Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M0 16C0 14.8954 0.895431 14 2 14C3.10457 14 4 14.8954 4 16C4 17.1046 3.10457 18 2 18C0.895431 18 0 17.1046 0 16Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M7 2C7 0.895431 7.89543 0 9 0C10.1046 0 11 0.895431 11 2C11 3.10457 10.1046 4 9 4C7.89543 4 7 3.10457 7 2Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M14 2C14 0.895431 14.8954 0 16 0C17.1046 0 18 0.895431 18 2C18 3.10457 17.1046 4 16 4C14.8954 4 14 3.10457 14 2Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9Z"
                                    fill="currentcolor" />
                                 <path
                                    d="M14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16Z"
                                    fill="currentcolor" />
                              </svg>
                           </div>
                        </nav>
                     </div>
                     <!-- Mobile Menu  -->
                     <div :class="{ 'show': side }" class="tgmobile__menu">
                        <nav class="tgmobile__menu-box">
                           <div class="close-btn" @click="toggleSideMenu"><i class="fas fa-times"></i></div>
                           <div class="nav-logo">
                              <a href="index.html"><img src="assets/img/logo/logo.png" alt="Logo" /></a>
                           </div>
                           <div class="tgmobile__search">
                              <form action="#">
                                 <input type="text" placeholder="Search here..." />
                                 <button><i class="fas fa-search"></i></button>
                              </form>
                           </div>
                           <div class="tgmobile__menu-outer">
                              <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header-->
                              <ul class="navigation">
                                 <li><router-link to="/">Beranda</router-link></li>
                                 <li :class="['menu-item-has-children', { active: isActiveMenu(['/berita']) }]">
                                    <a href="javascript:void(0)" @click="showInformasi = !showInformasi"
                                       :class="{ open: showInformasi }">Informasi</a>
                                    <ul class="sub-menu" :style="{ display: showInformasi ? 'block' : 'none' }">
                                       <li><router-link to="/berita">Berita</router-link></li>
                                       <li><a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank">Pengumuman</a></li>
                                    </ul>
                                    <div class="dropdown-btn" @click="showInformasi = !showInformasi"
                                       :class="{ open: showInformasi }">
                                       <span v-if="!showInformasi">+</span>
                                       <span v-else>−</span>
                                    </div>
                                 </li>
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/dataPegawai',
                                       '/profilDinas',
                                       '/tujuan',
                                       '/strategi',
                                       '/kebijakan',
                                       '/program',
                                       '/strukturOrganisasi'
                                    ])
                                 }]">
                                    <a href="javascript:void(0)" @click="showProfil = !showProfil" :class="{ open: showProfil }">Profil</a>
                                    <ul class="sub-menu" :style="{ display: showProfil ? 'block' : 'none' }">
                                       <li><router-link to="/dataPegawai">Data Pegawai</router-link></li>
                                       <li><router-link to="/profilDinas">Profil Dinas</router-link></li>
                                       <li><router-link to="/tujuan">Tujuan</router-link></li>
                                       <li><router-link to="/strategi">Strategi</router-link></li>
                                       <li><router-link to="/kebijakan">Kebijakan</router-link></li>
                                       <li><router-link to="/program">Program</router-link></li>
                                       <li><router-link to="/strukturOrganisasi">Struktur Organisasi</router-link></li>
                                    </ul>
                                    <div class="dropdown-btn" @click="showProfil = !showProfil"
                                       :class="{ open: showProfil }">
                                       <span v-if="!showProfil">+</span>
                                       <span v-else>−</span>
                                    </div>
                                 </li>
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/regulasi',
                                       '/dataDokumen'
                                    ])
                                 }]">
                                    <a href="javascript:void(0)" @click="showUnduhan = !showUnduhan" :class="{ open: showUnduhan }">Unduhan</a>
                                    <ul class="sub-menu" :style="{ display: showUnduhan ? 'block' : 'none' }">
                                       <li><router-link to="/regulasi">Regulasi</router-link></li>
                                       <li><router-link to="/dataDokumen">Data & Dokumen</router-link></li>
                                    </ul>
                                    <div class="dropdown-btn" @click="showUnduhan = !showUnduhan"
                                       :class="{ open: showUnduhan }">
                                       <span v-if="!showUnduhan">+</span>
                                       <span v-else>−</span>
                                    </div>
                                 </li>
                                 <li :class="['menu-item-has-children', {
                                    active: isActiveMenu([
                                       '/foto',
                                       '/video'
                                    ])
                                 }]">
                                    <a href="javascript:void(0)" @click="showGaleri = !showGaleri" :class="{ open: showGaleri }">Galeri</a>
                                    <ul class="sub-menu" :style="{ display: showGaleri ? 'block' : 'none' }">
                                       <li><router-link to="/foto">Foto</router-link></li>
                                       <li><router-link to="/video">Video</router-link></li>
                                    </ul>
                                    <div class="dropdown-btn" @click="showGaleri = !showGaleri"
                                       :class="{ open: showGaleri }">
                                       <span v-if="!showGaleri">+</span>
                                       <span v-else>−</span>
                                    </div>
                                 </li>
                              </ul>
                           </div>
                           <div class="tgmobile__menu-bottom">
                              <div class="contact-info">
                                 <ul class="list-wrap">
                                    <li><a href="mailto:dikbud@konaweselatankab.go.id">dikbud@konaweselatankab.go.id</a></li>
                                    <li><a href="tel:0123456789">+62 858-2430-7837</a></li>
                                 </ul>
                              </div>
                              <div class="social-links">
                                 <ul class="list-wrap">
                                    <li><a href="https://www.facebook.com/pages/Dinas-Pendidikan-Dan-Kebudayaan-Kab-Konawe-Selatan/873686546015176/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://www.instagram.com/dikbud_konsel/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                 </ul>
                              </div>
                           </div>
                        </nav>
                     </div>
                     <div class="tgmobile__menu-backdrop"></div>
                     <!-- End Mobile Menu -->
                  </div>
               </div>
            </div>
         </div>
      </header>
   </div>
</template>

<script>
export default {
   data() {
      return {
         isActive: false,
         side: false,
         showMobileMenu: false,
         showInformasi: false,
         showProfil: false,
         showUnitKerja: false,
         showPariwisata: false,
         showUnduhan: false,
         showDokumen: false,
         showGaleri: false,
      }
   },
   methods: {
      toggleSideMenu() {
         this.side = !this.side;
         // console.log("Side menu toggled:", this.side);

         if (this.side) {
            document.body.classList.add('mobile-menu-visible');
         } else {
            document.body.classList.remove('mobile-menu-visible');
         }
      },
      isActiveMenu(paths) {
         return paths.some(path => this.$route.path.startsWith(path));
      }
   }
}
</script>